import React from 'react';
import { Bar } from 'react-chartjs-2';
import Loader from '../../../common/loader';
import TooltipItem from './Tooltip';
import { Y_AXIS_SCALES } from '../../../common/constant';

const PerformanceGraph = ({
  headText = '',
  tooltipContent = '',
  tooltipPlace = 'left',
  PerformanceGraphLoader = 'show_block',
  barGraphData,
  tooltipOpen,
}) => {
  return (
    <div className='card'>
      <div className='card-header'>
        {headText}
        <div className='card-actions card_action_tooltip float-right'>
          <TooltipItem
            key='0'
            tooltipId='0'
            content={tooltipContent}
            place_tip={tooltipPlace}
            tooltipOpen={tooltipOpen}
          />
        </div>
      </div>
      <div className='card-block'>
        <div className={`main_loader  ${PerformanceGraphLoader}`}>
          <div className='loader-mid'>
            <div className='card-block-loader'>
              <Loader />
            </div>
          </div>
        </div>
        <div className='chart-wrapper performance-chart-wrapper'>
          {barGraphData.labels && (
            <Bar
              data={barGraphData}
              options={{
                maintainAspectRatio: false,
                ...Y_AXIS_SCALES,
                tooltips: {
                  callbacks: {
                    label: function(tooltipItem, data) {
                      return (
                        data.datasets[tooltipItem.datasetIndex].label +
                        ': ' +
                        tooltipItem.yLabel +
                        '%'
                      );
                    },
                  },
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformanceGraph;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/PerformanceGraph.jsx